/* ELIGE — countdown, selección de edición, pestañas y barra fija */
(function () {
  'use strict';

  /* Altura real del header → offset del sticky countdown */
  function setHeaderH() {
    var h = document.querySelector('.f-header');
    document.documentElement.style.setProperty('--elige-header-h', (h ? h.offsetHeight : 0) + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);
  window.addEventListener('load', setHeaderH);

  /* Cuenta regresiva — todos los [data-elige-deadline] */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-elige-deadline]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var t = Date.parse(el.getAttribute('data-elige-deadline'));
      if (isNaN(t)) continue;
      var diff = t - Date.now();
      var live = diff <= 0;
      if (live) diff = 0;
      var s = Math.floor(diff / 1000);
      var v = {
        d: Math.floor(s / 86400),
        h: Math.floor((s % 86400) / 3600),
        m: Math.floor((s % 3600) / 60),
        s: s % 60
      };
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var boxes = el.querySelectorAll('[data-cd-' + k + ']');
        for (var j = 0; j < boxes.length; j++) boxes[j].textContent = pad(v[k]);
      });
      var bar = el.classList.contains('elg-cd') ? el : el.closest('.elg-cd');
      if (bar) bar.classList.toggle('is-live', live);
    }
  }
  tick();
  setInterval(tick, 1000);

  /* Selección de edición → actualiza CTA (texto + destino) */
  document.querySelectorAll('[data-elige-tiers]').forEach(function (root) {
    var cta = root.querySelector('[data-elige-cta]');
    root.querySelectorAll('input[name="elige-tier"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        root.querySelectorAll('.elg-tier').forEach(function (card) {
          card.classList.toggle('is-selected', card.contains(radio));
        });
        if (cta) {
          cta.setAttribute('href', radio.getAttribute('data-url'));
          var label = cta.querySelector('[data-cta-text]');
          if (label) label.textContent = radio.getAttribute('data-cta');
        }
      });
    });
  });

  /* Pestañas ENTRADA + LIBRO / SOLO LIBRO */
  document.querySelectorAll('[data-elige-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-elige-panels-wrap]');
      if (!wrap) return;
      var target = btn.getAttribute('data-elige-tab');
      wrap.querySelectorAll('[data-elige-tab]').forEach(function (b) {
        var active = b.getAttribute('data-elige-tab') === target;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      wrap.querySelectorAll('[data-elige-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-elige-panel') !== target;
      });
    });
  });

  /* Lead magnet: adjunta el WhatsApp escrito al mensaje que se envía al negocio */
  document.querySelectorAll('[data-elige-wa]').forEach(function (a) {
    a.addEventListener('click', function () {
      var base = a.getAttribute('href');
      if (!base || base.indexOf('wa.me') === -1) return;
      var input = document.querySelector('[data-elige-wa-input]');
      var num = input && input.value ? input.value.trim() : '';
      if (!num) return;
      var sep = base.indexOf('?') === -1 ? '?text=' : '';
      var extra = encodeURIComponent('\nMi WhatsApp: ' + num);
      a.setAttribute('href', base + sep + extra);
    });
  });
})();


/* ===== ELIGE — La Gira (movido desde la sección para pasar el importador de Shopify) ===== */
(function () {
  'use strict';
  if (window.__eligeGiraInit) return;
  window.__eligeGiraInit = true;

  /* Domingo del mismo fin de semana de cada fecha regional del Desafío Sammis Reyes (sábados).
     Evento: domingo 10:00–11:30. */
  var REGIONS = [
    { name: 'Arica y Parinacota', day: '31', month: 'Jul', iso: '2026-07-31T18:30:00-04:00', desafio: 'Sáb 01 Ago' },
    { name: 'Tarapacá',           day: '09', month: 'Ago', iso: '2026-08-09T10:00:00-04:00', desafio: 'Sáb 08 Ago',
      venue: { name: 'Hotel Gavina · Centro de Eventos', addr: 'Av. Arturo Prat 1497, Iquique', map: 'https://www.google.com/maps/search/?api=1&query=Hotel%20Gavina%2C%20Av.%20Arturo%20Prat%201497%2C%20Iquique' } },
    { name: 'Antofagasta',        day: '15', month: 'Ago', iso: '2026-08-15T21:00:00-04:00', desafio: 'Sáb 15 Ago', dow: 'Sáb', hours: '21:00 a 23:00 hrs', sameDay: true,
      venue: { name: 'Salón de Conferencias · Hotel Enjoy Antofagasta', addr: 'Av. Angamos 01455, Antofagasta', map: 'https://www.google.com/maps/search/?api=1&query=Hotel%20Enjoy%20Antofagasta%2C%20Av.%20Angamos%2001455%2C%20Antofagasta' } },
    { name: 'Calama',             day: '16', month: 'Ago', iso: '2026-08-16T18:00:00-04:00', desafio: 'Sáb 15 Ago', hours: '18:00 a 20:00 hrs',
      venue: { name: 'Centro Deportivo Olivos Sport', addr: 'Av. Balmaceda Sur 224, Calama', map: 'https://www.google.com/maps/search/?api=1&query=Centro%20Deportivo%20Olivos%20Sport%2C%20Av.%20Balmaceda%20Sur%20224%2C%20Calama' } },
    { name: 'Atacama',            day: '23', month: 'Ago', iso: '2026-08-23T10:00:00-04:00', desafio: 'Sáb 22 Ago' },
    { name: 'Coquimbo',           day: '06', month: 'Sep', iso: '2026-09-06T12:00:00-03:00', desafio: 'Sáb 05 Sep', hours: '12:00 a 13:30 hrs',
      venue: { name: 'Hotel La Serena Suite', addr: 'Ruta 5 Norte, km 470, La Serena', map: 'https://www.google.com/maps/search/?api=1&query=Hotel%20La%20Serena%20Suite%2C%20Ruta%205%20Norte%20km%20470%2C%20La%20Serena' } },
    { name: 'Valparaíso',         day: '27', month: 'Sep', iso: '2026-09-27T12:00:00-03:00', desafio: 'Sáb 26 Sep', hours: 'por confirmar', venue: { name: 'Por confirmar', addr: '', map: '' } },
    { name: "O'Higgins",          day: '13', month: 'Sep', iso: '2026-09-13T17:00:00-03:00', desafio: 'Sáb 12 Sep', free: true, hours: '17:00 hrs', whatsapp: 'https://wa.me/56944030697',
      venue: { name: 'Colonial Restobar', addr: 'Pablo Rubio 232, Requínoa', map: 'https://www.google.com/maps/search/?api=1&query=Colonial%20Restobar%2C%20Pablo%20Rubio%20232%2C%20Requinoa' } },
    { name: 'Maule',              day: '04', month: 'Oct', iso: '2026-10-04T12:00:00-03:00', desafio: 'Sáb 03 Oct' },
    { name: 'Ñuble',              day: '11', month: 'Oct', iso: '2026-10-11T12:00:00-03:00', desafio: 'Sáb 10 Oct' },
    { name: 'Biobío',             day: '18', month: 'Oct', iso: '2026-10-18T12:00:00-03:00', desafio: 'Sáb 17 Oct' },
    { name: 'La Araucanía',       day: '25', month: 'Oct', iso: '2026-10-25T12:00:00-03:00', desafio: 'Sáb 24 Oct' },
    { name: 'Los Ríos',           day: '01', month: 'Nov', iso: '2026-11-01T12:00:00-03:00', desafio: 'Sáb 31 Oct' },
    { name: 'Los Lagos',          day: '08', month: 'Nov', iso: '2026-11-08T12:00:00-03:00', desafio: 'Sáb 07 Nov' },
    { name: 'Aysén',              day: '22', month: 'Nov', iso: '2026-11-22T12:00:00-03:00', desafio: 'Sáb 21 Nov' },
    { name: 'Magallanes',         day: '29', month: 'Nov', iso: '2026-11-29T12:00:00-03:00', desafio: 'Sáb 28 Nov' },
    { name: 'Santiago',           day: '13', month: 'Dic', iso: '2026-12-13T12:00:00-03:00', desafio: 'Sáb 12 Dic · Gran Final' }
  ];
  var BYDATE = REGIONS.slice().sort(function(a,b){ return Date.parse(a.iso) - Date.parse(b.iso); });

  /* El evento pasó de viernes 18:30 a domingo 10:00–11:30. Los textos fijos viven en
     secciones .liquid que el API no deja actualizar; se corrigen aquí sobre el DOM.
     Si el tema se re-sube ya corregido, estos reemplazos no encuentran nada y no hacen nada. */
  function patchDayTexts() {
    var reps = [
      ['cada viernes previo, una noche exclusiva', 'cada domingo (12:00 a 13:30 hrs), una mañana exclusiva'],
      ['Cada viernes previo a la fecha regional del Desafío hay una noche exclusiva', 'Cada domingo del fin de semana del Desafío hay un encuentro exclusivo, de 12:00 a 13:30 hrs'],
      ['Siempre el viernes previo a la fecha del Desafío Sammis Reyes en tu región: desde el 31 de julio en Arica y Parinacota hasta el 4 de diciembre en Santiago.', 'Siempre el domingo, de 12:00 a 13:30 hrs, el mismo fin de semana del Desafío Sammis Reyes en tu región: desde Arica y Parinacota hasta el 13 de diciembre en Santiago.'],
      ['Son dos noches de una misma parada: el viernes es la noche del libro y el sábado tu región compite en el Desafío Sammis Reyes.', 'Son dos jornadas de un mismo fin de semana: el sábado tu región compite en el Desafío Sammis Reyes y el domingo, de 12:00 a 13:30 hrs, es la jornada del libro.'],
      ['viernes de la gira', 'domingo de la gira'],
      ['NOS VEMOS A LAS 18:30', 'NOS VEMOS A LAS 12:00'],
      ['El sábado siguiente (', 'El sábado anterior ('],
      ['16 regiones · 100 cupos General y 20 Mastermind por región', '16 regiones · 100 cupos por región']
    ];
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (!t || t.length < 12) continue;
      for (var i = 0; i < reps.length; i++) {
        if (t.indexOf(reps[i][0]) !== -1) t = t.split(reps[i][0]).join(reps[i][1]);
      }
      /* el horario solo se agrega si el texto aún no lo trae (el tema v15+ ya lo hornea) */
      if (t.indexOf('Café y bebestibles incluidos.') !== -1 && t.indexOf('Horario:') === -1) {
        t = t.replace('Café y bebestibles incluidos.', 'Café y bebestibles incluidos. Horario: 12:00 a 13:30 hrs.');
      }
      if (t !== node.nodeValue) node.nodeValue = t;
    }
    var dow = document.querySelector('[data-gira-dow]');
    if (dow && dow.textContent.replace(/\s+/g, '') === 'VIE') dow.textContent = 'DOM';
  }

  /* Solo se vende la entrada General: si el HTML del tema aún trae las tarjetas
     Mastermind (VIP) / Experiencia Privada o la columna Mastermind de la tabla
     (secciones .liquid no actualizables por API), se eliminan del DOM.
     No-op cuando el tema ya viene sin ellas (v18+). */
  function stripTiers() {
    document.querySelectorAll('.elg-gtier--vip, .elg-gtier--priv').forEach(function (el) {
      el.parentNode.removeChild(el);
    });

    /* tabla desktop: quitar la columna Mastermind (3ª de 5) y la fila "Cena privada" */
    var grid = document.querySelector('.elg-tabla__grid');
    if (grid) {
      var heads = grid.querySelectorAll('.elg-tabla__head');
      var vipHead = null;
      heads.forEach(function (h) { if (h.textContent.indexOf('Mastermind') !== -1) vipHead = h; });
      if (vipHead) {
        var cells = Array.prototype.slice.call(grid.children);
        var start = cells.indexOf(vipHead) - 2; /* primera celda de la fila de heads */
        /* desde la fila de heads en adelante, filas de 5: eliminar la 3ª celda de cada una */
        for (var i = start + 2; i < cells.length; i += 4) { /* +4: la fila queda de 4 tras cada remoción */
          if (cells[i] && cells[i].parentNode) grid.removeChild(cells[i]);
          cells.splice(i, 1);
        }
        /* fila "Cena privada" (ya de 4 celdas) */
        var cena = null;
        grid.querySelectorAll('.elg-tabla__label').forEach(function (l) {
          if (l.textContent.indexOf('Cena privada') !== -1) cena = l;
        });
        if (cena) {
          var rest = Array.prototype.slice.call(grid.children);
          var at = rest.indexOf(cena);
          for (var k = 0; k < 4; k++) { if (rest[at + k]) grid.removeChild(rest[at + k]); }
        }
        grid.style.gridTemplateColumns = '1.35fr 1.15fr 0.95fr 0.95fr';
        var go = grid.querySelector('.elg-tabla__group--go');
        if (go) go.style.gridColumn = 'span 1';
      }
    }

    /* tabla móvil: tarjeta Mastermind */
    document.querySelectorAll('.elg-tabla__scard').forEach(function (c) {
      var b = c.querySelector('b');
      if (b && b.textContent.indexOf('Mastermind') !== -1) c.parentNode.removeChild(c);
    });

    /* nota dorada "‡ Mastermind: cena privada…" */
    document.querySelectorAll('.elg-tabla__fn--gold').forEach(function (fn) {
      if (fn.textContent.indexOf('Mastermind') !== -1) fn.parentNode.removeChild(fn);
    });
  }

  function init() {
    patchDayTexts();
    stripTiers();
    var root = document.getElementById('gira');
    if (!root) return;

    var DATA = { g: {}, fallback: '', capG: 100 };
    DATA.fallback = root.getAttribute('data-gira-fallback') || '';
    DATA.capG = parseInt(root.getAttribute('data-gira-capg'), 10) || 100;
    var HANDLES = { g: root.getAttribute('data-gira-gral') || '' };

    /* Badge de cupos en General; no-op si ya viene del tema */
    var gTier = root.querySelector('input[name="elige-gira-tier"][value="g"]');
    var gCard = gTier && gTier.closest('.elg-gtier');
    var gName = gCard && gCard.querySelector('.elg-gtier__name');
    if (gName && !gName.querySelector('.elg-gtier__badge')) {
      var gBadge = document.createElement('span');
      gBadge.className = 'elg-gtier__badge';
      gBadge.textContent = DATA.capG + ' cupos';
      gName.appendChild(document.createTextNode(' '));
      gName.appendChild(gBadge);
    }

    var mapEl = root.querySelector('[data-gira-map]');
    var selectEl = root.querySelector('[data-gira-select]');
    var ctaEl = root.querySelector('[data-gira-cta]');
    var ctaTextEl = root.querySelector('[data-gira-cta-text]');
    var soldoutEl = root.querySelector('[data-gira-soldout]');
    var els = {
      region: root.querySelector('[data-gira-region]'),
      day: root.querySelector('[data-gira-day]'),
      month: root.querySelector('[data-gira-month]'),
      dow: root.querySelector('[data-gira-dow]'),
      note: root.querySelector('[data-gira-note]'),
      desafio: root.querySelector('[data-gira-desafio]'),
      leftG: root.querySelector('[data-gira-left-g]')
    };

    /* Línea de lugar del evento (solo regiones con venue confirmado).
       Se inyecta en la caja de nota, antes de la línea del Desafío. */
    var venueEl = root.querySelector('[data-gira-venue]');
    if (!venueEl) {
      var noteBox = root.querySelector('.elg-gira__note');
      if (noteBox) {
        venueEl = document.createElement('span');
        venueEl.className = 'elg-gira__desafio';
        venueEl.setAttribute('data-gira-venue', '');
        venueEl.hidden = true; venueEl.style.display = 'none';;
        venueEl.innerHTML = '📍 Lugar: <b data-gira-venue-name></b><span data-gira-venue-addrwrap> · <span data-gira-venue-addr></span></span><span data-gira-venue-mapwrap> · <a data-gira-venue-map target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">Ver mapa</a></span>';
        noteBox.insertBefore(venueEl, noteBox.querySelector('.elg-gira__desafio'));
      }
    }
    var ctaBase = (ctaTextEl && ctaTextEl.textContent || 'Asegura tu cupo').replace(/\s+en\s+.*$/i, '');
    var now = Date.now();

    function variantFor(r) {
      return DATA.g ? DATA.g[r.name.toLowerCase()] : null;
    }
    function isPast(r) { return Date.parse(r.iso) + 6 * 3600 * 1000 < now; } /* pasada 6h después del inicio */
    function tierLeft(r) {
      var vv = variantFor(r);
      if (!vv) return null;                    /* sin variante cargada → mostrar cupo */
      return vv.avail ? null : 0;              /* disponible → cupo; no disponible → agotado */
    }
    function buyUrl(r) {
      if (r.free && r.whatsapp) return r.whatsapp;
      var vv = variantFor(r);
      if (vv && vv.avail && (vv.qty === null || vv.qty > 0)) return '/cart/' + vv.id + ':1';
      if (DATA.fallback) {
        var sep = DATA.fallback.indexOf('?') === -1 ? '?' : '&';
        return DATA.fallback + sep + 'region=' + encodeURIComponent(r.name) + '&entrada=general';
      }
      return '#gira';
    }

    var dots = [];
    var current = null;

    function render(r) {
      current = r;
      if (els.region) els.region.textContent = r.name;
      if (els.day) els.day.textContent = r.day;
      if (els.month) els.month.textContent = r.month.toUpperCase();
      if (els.dow) els.dow.textContent = (r.dow || 'Dom').toUpperCase();
      if (els.note) els.note.textContent = els.note.textContent.replace(/Horario:\s*[^.]*\./, 'Horario: ' + (r.hours || '12:00 a 13:30 hrs') + '.');
      if (els.desafio) {
        els.desafio.textContent = r.desafio;
        /* "El sábado anterior (…)" no aplica cuando la charla es el mismo sábado del Desafío */
        var dLine = els.desafio.parentNode;
        if (dLine && dLine.firstChild && dLine.firstChild.nodeType === 3) {
          dLine.firstChild.nodeValue = r.sameDay ? 'Ese mismo sábado (' : 'El sábado anterior (';
        }
      }

      if (venueEl) {
        if (r.venue) {
          venueEl.querySelector('[data-gira-venue-name]').textContent = r.venue.name;
          venueEl.querySelector('[data-gira-venue-addr]').textContent = r.venue.addr;
          var mapA = venueEl.querySelector('[data-gira-venue-map]');
          if (r.venue.map) { mapA.setAttribute('href', r.venue.map); mapA.hidden = false; } else { mapA.hidden = true; }
          venueEl.hidden = false; venueEl.style.display = '';;
        } else {
          venueEl.hidden = true; venueEl.style.display = 'none';;
        }
      }

      var lg = tierLeft(r);
      if (els.leftG) els.leftG.textContent = lg === null ? DATA.capG + ' cupos por región' : (lg > 0 ? 'Quedan ' + lg + ' de ' + DATA.capG : 'Agotada en esta región');

      var past = isPast(r);
      var out = past || lg === 0;
      if (ctaEl) {
        ctaEl.classList.toggle('is-disabled', out);
        ctaEl.removeAttribute('target');
        ctaEl.removeAttribute('rel');
        ctaEl.setAttribute('href', out ? '#gira' : buyUrl(r));
        if (ctaTextEl) ctaTextEl.textContent = past ? ('Realizada — ' + r.name) : (out ? 'Agotado en ' + r.name : ctaBase + ' en ' + r.name);
      }
      if (soldoutEl) soldoutEl.hidden = !out || past;

      dots.forEach(function (d, i) { d.classList.toggle('is-on', REGIONS[i] === r); });
      if (selectEl) selectEl.value = String(REGIONS.indexOf(r));
    }

    /* ——— dots del mapa ——— */
    var n = REGIONS.length;
    REGIONS.forEach(function (r, i) {
      var top = n > 1 ? (4 + (i * (92 / (n - 1)))) : 50;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'elg-mapdot' + (isPast(r) ? ' is-past' : '');
      btn.style.top = top + '%';
      var meta = isPast(r) ? ('✓ Realizada · ' + r.day + ' ' + r.month) : (r.day + ' ' + r.month + ' · ' + (r.dow || 'Dom'));
      btn.innerHTML = '<span class="dot"></span><span class="lbl"><span class="rname"></span><span class="rmeta"></span></span>';
      btn.querySelector('.rname').textContent = r.name;
      btn.querySelector('.rmeta').textContent = meta;
      btn.addEventListener('mouseenter', function () { render(r); });
      btn.addEventListener('focus', function () { render(r); });
      btn.addEventListener('click', function (ev) { ev.preventDefault(); render(r); });
      mapEl.appendChild(btn);
      dots.push(btn);
    });

    /* ——— selector móvil ——— */
    if (selectEl) {
      REGIONS.forEach(function (r, i) {
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = r.name + ' — ' + (isPast(r) ? '' : (r.dow || 'Dom') + ' ') + r.day + ' ' + r.month + (isPast(r) ? ' (realizada)' : '');
        selectEl.appendChild(opt);
      });
      selectEl.addEventListener('change', function () { render(REGIONS[parseInt(selectEl.value, 10)] || REGIONS[0]); });
    }

    /* ——— "ver la próxima fecha disponible" ——— */
    var nextOpenBtn = root.querySelector('[data-gira-next-open]');
    if (nextOpenBtn) nextOpenBtn.addEventListener('click', function () {
      var next = BYDATE.filter(function (r) { return !isPast(r); }).find(function (r) {
        return tierLeft(r) !== 0;
      });
      if (next) render(next);
    });

    /* ——— variantes por región en vivo (Shopify AJAX API) ——— */
    function loadVariants() {
      var h = HANDLES.g;
      if (!h || !window.fetch) return;
      fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          if (!p || !p.variants) return;
          p.variants.forEach(function (v) {
            var key = (v.option1 || v.title || '').toLowerCase();
            DATA.g[key] = { id: v.id, avail: v.available, qty: null };
          });
          if (current) render(current);
          updateStickyCta();
        })
        .catch(function () {});
    }

    /* ——— barra fija móvil: CTA directo al checkout de la próxima parada
           (la misma región que muestra el label data-gira-next). Mientras las
           variantes no cargan —o si la parada está agotada— queda el ancla #gira. ——— */
    function updateStickyCta() {
      var nx = BYDATE.find(function (r) { return !isPast(r); });
      if (!nx) return;
      var url = buyUrl(nx);
      if (url.indexOf('/cart/') !== 0 && url.indexOf('https://wa.me') !== 0) return;
      document.querySelectorAll('.elg-stickybar__btn').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }

    /* ——— región inicial: la próxima por venir ——— */
    var first = BYDATE.find(function (r) { return !isPast(r); }) || REGIONS[n - 1];
    var __stdNote = els.note ? els.note.textContent : '';
    var __stdTrust = null;
    var __render0 = render;
    render = function (r) {
      __render0(r);
      var vEl = root.querySelector('[data-gira-venue]');
      if (vEl) {
        var aw = vEl.querySelector('[data-gira-venue-addrwrap]');
        var mw = vEl.querySelector('[data-gira-venue-mapwrap]');
        if (aw) aw.style.display = r.venue && r.venue.addr ? '' : 'none';
        if (mw) mw.style.display = r.venue && r.venue.map ? '' : 'none';
      }
      var free = !!r.free;
      var tiers = root.querySelector('[data-gira-tiers]');
      var trust = root.querySelector('.elg-gira__trust');
      if (tiers) tiers.style.display = free ? 'none' : '';
      if (els.note) {
        if (free) {
          els.note.textContent = 'Charla de presentación del libro + meet & greet con Sammis. ENTRADA LIBERADA — reserva tu cupo por WhatsApp al +56 9 4403 0697. Horario: ' + (r.hours || '17:00 hrs') + '.';
        } else if (__stdNote) {
          els.note.textContent = __stdNote.replace(/Horario:\s*[^.]*\./, 'Horario: ' + (r.hours || '12:00 a 13:30 hrs') + '.');
        }
      }
      if (trust) {
        if (free) {
          if (__stdTrust === null) __stdTrust = trust.innerHTML;
          trust.innerHTML = '<span>Entrada liberada</span><span class="elg-trust__dot">·</span><span>Cupos limitados</span><span class="elg-trust__dot">·</span><span>Reservas por WhatsApp: +56 9 4403 0697</span>';
        } else if (__stdTrust !== null) {
          trust.innerHTML = __stdTrust; __stdTrust = null;
        }
      }
      if (free && ctaEl && !isPast(r)) {
        ctaEl.classList.remove('is-disabled');
        ctaEl.setAttribute('href', r.whatsapp + '?text=' + encodeURIComponent('Hola! Quiero reservar mi cupo para la charla gratuita de Sammis en ' + r.name + ' — ' + (r.dow || 'Dom') + ' ' + r.day + ' ' + r.month + ', ' + (r.hours || '') + ', ' + (r.venue && r.venue.name || '') + '.'));
        ctaEl.setAttribute('target', '_blank');
        ctaEl.setAttribute('rel', 'noopener');
        if (ctaTextEl) ctaTextEl.textContent = 'Reserva gratis tu cupo por WhatsApp';
        if (soldoutEl) soldoutEl.hidden = true;
      }
    };
    render(first);
    loadVariants();

    /* ——— countdown global → próxima parada de la gira ——— */
    var next = BYDATE.find(function (r) { return !isPast(r); });
    if (next) {
      document.querySelectorAll('[data-elige-deadline]').forEach(function (el) {
        el.setAttribute('data-elige-deadline', next.iso);
      });
      document.querySelectorAll('[data-gira-next]').forEach(function (el) {
        el.textContent = next.day + ' ' + next.month.toUpperCase() + ' · ' + next.name.toUpperCase();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ===== ELIGE — 10 enseñanzas: fallback + swipe.
   Si la sección llega sin blocks (settings_data del tema sin la sección, como
   pasó al publicar v15), el script inline de la sección aborta y el carrusel
   queda vacío. Este init de respaldo usa las 10 enseñanzas por defecto y
   replica el comportamiento (diagramas SVG animados, dots, flechas) + swipe
   táctil. Si la sección ya se inicializó sola, aquí solo se agrega el swipe. ===== */
(function () {
  'use strict';
  var DEFAULT_ITEMS = [
    'Distinguir tu personalidad de tu identidad.',
    'Decir "yo soy así" es una cárcel.',
    'Reconocer las 4 trampas de "yo soy así".',
    'Distinguir tus metas reales de las que te impusieron.',
    'Ver los automatismos que te dirigen sin que lo notes.',
    'El método para construir identidad paso a paso.',
    'El precio de construir una identidad propia.',
    'Administrar tu identidad en vez de obedecerla.',
    'Cómo sostener tu identidad cuando el mundo te pone a prueba.',
    'Pensar en tu legado te ayuda a solidificar tu identidad.'
  ];
  function initEns() {
    var root = document.querySelector('[data-elige-ens]');
    if (!root) return;
    var dotsEl = root.querySelector('[data-ens-dots]');
    var prevBtn = root.querySelector('[data-ens-prev]');
    var nextBtn = root.querySelector('[data-ens-next]');

    /* swipe táctil (aplica siempre, haya o no fallback) */
    var stage = root.querySelector('.elg-ens__stage') || root;
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      var btn = dx < 0 ? nextBtn : prevBtn;
      if (btn && !btn.disabled) btn.click();
    }, { passive: true });

    if (!dotsEl || dotsEl.children.length) return; /* la sección ya se inicializó sola */

    var items = DEFAULT_ITEMS;
    try {
      var parsed = JSON.parse(root.querySelector('[data-ens-items]').textContent);
      if (parsed && parsed.length) items = parsed;
    } catch (e) {}

    var diagrams = root.querySelectorAll('.elg-ens__diagram');
    var numEl = root.querySelector('[data-ens-num]');
    var titleEl = root.querySelector('[data-ens-title]');
    var idxEl = root.querySelector('[data-ens-idx]');
    var totalEl = root.querySelector('[data-ens-total]');
    var i = 0;
    if (totalEl) totalEl.textContent = items.length;
    var dots = items.map(function (_, j) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'elg-ens__dot';
      d.setAttribute('aria-label', 'Enseñanza ' + (j + 1));
      d.addEventListener('click', function () { go(j); });
      dotsEl.appendChild(d);
      return d;
    });
    function render() {
      if (numEl) numEl.textContent = ('0' + (i + 1)).slice(-2);
      if (titleEl) titleEl.textContent = items[i];
      if (idxEl) idxEl.textContent = i + 1;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      diagrams.forEach(function (svg, j) { svg.classList.toggle('is-active', j === i % diagrams.length); });
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === items.length - 1;
    }
    function go(j) {
      if (j === i || j < 0 || j >= items.length) return;
      root.classList.add('is-out');
      setTimeout(function () {
        i = j;
        render();
        root.classList.remove('is-out');
      }, 60);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(i + 1); });
    render();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEns);
  } else {
    initEns();
  }
})();

/* ============================================================
   ELIGE — retiro del E-BOOK de la venta online (2026-08-07).
   Solo se vende el libro FÍSICO: elimina del DOM la tarjeta
   E-book del héroe, su columna en la tabla comparativa y las
   menciones "entrega inmediata". No-op si el tema ya viene
   sin e-book (v19+).
   ============================================================ */
(function () {
  if (window.__eligeEbookStrip) return;
  window.__eligeEbookStrip = true;

  function stripEbook() {
    /* héroe: tarjeta E-book fuera; la de libro físico ocupa todo el ancho */
    document.querySelectorAll('.elg-presale__card').forEach(function (c) {
      var k = c.querySelector('.elg-presale__k');
      if (k && /e-?book/i.test(k.textContent)) c.parentNode.removeChild(c);
    });
    document.querySelectorAll('.elg-presale').forEach(function (p) {
      if (p.querySelectorAll('.elg-presale__card').length === 1) {
        p.style.gridTemplateColumns = '1fr';
      }
    });

    /* nota de confianza "· E-book de entrega inmediata" */
    document.querySelectorAll('.elg-trust span').forEach(function (s) {
      if (/e-?book/i.test(s.textContent)) {
        s.textContent = s.textContent
          .replace(/\s*·\s*E-?book de entrega inmediata/i, '')
          .replace(/E-?book de entrega inmediata\s*·?\s*/i, '');
      }
    });

    /* tabla desktop: columna E-book (última de 4) */
    var grid = document.querySelector('.elg-tabla__grid');
    if (grid) {
      var eHead = null;
      grid.querySelectorAll('.elg-tabla__head').forEach(function (h) {
        if (/e-?book/i.test(h.textContent)) eHead = h;
      });
      if (eHead) {
        var cells = Array.prototype.slice.call(grid.children);
        for (var i = cells.indexOf(eHead); i < cells.length; i += 4) {
          if (cells[i] && cells[i].parentNode === grid) grid.removeChild(cells[i]);
        }
        grid.style.gridTemplateColumns = '1.35fr 1.15fr 0.95fr';
        var pre = grid.querySelector('.elg-tabla__group--pre');
        if (pre) pre.style.gridColumn = 'span 1';
      }
    }

    /* tarjeta móvil "Solo el libro" y FAQ */
    document.querySelectorAll('.elg-tabla__scard span, .elg-faq__a').forEach(function (el) {
      if (/e-?book/i.test(el.textContent)) {
        el.textContent = el.textContent
          .replace(/\s*·\s*E-?book[^·]*\(entrega inmediata\)/i, '')
          .replace(/,?\s*o e-?book de entrega inmediata en tu email\.?/i, '.');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripEbook);
  } else {
    stripEbook();
  }
})();
